import { useState } from "react";
import { Radio } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { ROLE_COLORS } from "@/lib/palettes";

const QUICK_MSGS = ["👋 Ping!", "☕ Coffee break?", "🔍 Need a quick review!", "🚨 Urgent — look at this!"];

export default function PingCard({ users, me, online = [] }) {
  const [msg, setMsg] = useState(QUICK_MSGS[0]);
  const [sent, setSent] = useState({});
  const others = users.filter((u) => u.id !== me.id);

  const ping = async (u) => {
    try {
      await api.post("/pings", { to_id: u.id, message: msg });
      setSent((s) => ({ ...s, [u.id]: true }));
      setTimeout(() => setSent((s) => ({ ...s, [u.id]: false })), 2000);
      toast.success(`Pinged ${u.name} 📡`);
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-2">
      <select data-testid="ping-message-select" value={msg} onChange={(e) => setMsg(e.target.value)}
        className="w-full rounded-lg bg-black/10 dark:bg-white/10 px-2 py-1.5 text-xs outline-none cursor-pointer">
        {QUICK_MSGS.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
      <div className="max-h-48 space-y-1.5 overflow-y-auto">
        {others.map((u) => (
          <div key={u.id} className="flex items-center gap-2 rounded-xl bg-white/40 dark:bg-black/25 px-2 py-1.5">
            <div className="relative">
              <div className="flex h-7 w-7 items-center justify-center rounded-full bg-gradient-to-br from-violet-400 to-pink-400 text-xs font-bold text-white">
                {(u.name || "?")[0].toUpperCase()}
              </div>
              {online.includes(u.id) && (
                <span data-testid={`online-dot-${u.email.split("@")[0]}`} title="Online now"
                  className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-green-500 ring-2 ring-white dark:ring-slate-800 animate-pulse" />
              )}
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate text-xs font-semibold">{u.name}</div>
              <div className={`inline-block rounded-full border px-1.5 text-[9px] font-mono uppercase ${ROLE_COLORS[u.role]}`}>{u.role}</div>
            </div>
            <button data-testid={`ping-user-${u.email.split("@")[0]}`} onClick={() => ping(u)}
              className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold text-white shadow transition-all active:scale-90 ${
                sent[u.id] ? "bg-green-500" : "bg-gradient-to-r from-pink-500 to-violet-500 hover:scale-105"
              }`}>
              <Radio className="h-3 w-3" /> {sent[u.id] ? "Sent!" : "Ping"}
            </button>
          </div>
        ))}
        {others.length === 0 && <p className="text-center font-hand text-lg opacity-50">no teammates yet</p>}
      </div>
    </div>
  );
}
